import { RRA_ACTION_LINK } from 'react-redux-app/lib/modules/actionLink/constants';
import { RRA_ALERT } from 'react-redux-app/lib/modules/alert/constants';
import { RRA_CONTEXT_MENU_LINK } from 'react-redux-app/lib/modules/contextMenuLink/constants';
import { RRA_BUTTON } from 'react-redux-app/lib/modules/button/constants';
import { RRA_BUTTON_SET } from 'react-redux-app/lib/modules/buttonSet/constants';
import { RRA_CONFIRMATION } from 'react-redux-app/lib/modules/confirmation/constants';
import { RRA_DROP_DOWN_MENU } from 'react-redux-app/lib/modules/dropDownMenu/constants';
import { RRA_GRID_PAGINATION } from 'react-redux-app/lib/modules/gridPagination/constants';
import { RRA_GRID_PLACEHOLDER } from 'react-redux-app/lib/modules/grid/constants';
import { RRA_HEADING } from 'react-redux-app/lib/modules/heading/constants';
import { RRA_LINK } from 'react-redux-app/lib/modules/link/constants';
import { RRA_PAGINATION } from 'react-redux-app/lib/modules/pagination/constants';
import { RRA_TABLE, RRA_VERT_TABLE } from 'react-redux-app/lib/modules/table/constants';
import { RRA_TABLE_SUMMARY } from 'react-redux-app/lib/modules/tableSummary/constants';

import {
  RRA_FORM_AUTOCOMPLETE,
  RRA_FORM_CHECKBOX,
  RRA_FORM_DAY_MONTH_YEAR,
  RRA_FORM_ERROR,
  RRA_FORM_FIELD,
  RRA_FORM_IBAN,
  RRA_FORM_INPUT,
  RRA_FORM_INPUT_FILE,
  RRA_FORM_INPUT_PASSWORD,
  RRA_FORM_INPUT_TEXT_WITH_ADDON,
  RRA_FORM_MULTI_SELECT,
  RRA_FORM_RADIO_BUTTON,
  RRA_FORM_TEXTAREA,
} from 'react-redux-app/lib/modules/form/constants';

import {
  RRA_MENU,
  RRA_MENU_ITEM,
  RRA_MENU_ITEM_LINK,
  RRA_MENU_SUBMENU,
  RRA_MENU_SUBMENU_ITEM,
  RRA_MENU_SUBMENU_ITEM_LINK,
} from 'react-redux-app/lib/modules/menu/constants';

import { RRA_MODAL, RRA_MODALS_STACK } from 'react-redux-app/lib/modules/modal/constants';

import actionLinkTheme from '../styles/libs/react-redux-app/ActionLink/index.css.json';
import alertTheme from '../styles/libs/react-redux-app/Alert/index.css.json';
import buttonTheme from '../styles/libs/react-redux-app/Button/index.css.json';
import buttonSetTheme from '../styles/libs/react-redux-app/ButtonSet/index.css.json';
import confirmationTheme from '../styles/libs/react-redux-app/Confirmation/index.css.json';
import contextMenuTheme from '../styles/libs/react-redux-app/ContextMenuLink/index.css.json';
import dropDownMenuTheme from '../styles/libs/react-redux-app/DropDownMenu/index.css.json';
import gridPaginationTheme from '../styles/libs/react-redux-app/GridPagination/index.css.json';
import gridPlaceholerTheme from '../styles/libs/react-redux-app/GridPlaceholder/index.css.json';
import headingTheme from '../styles/libs/react-redux-app/Heading/index.css.json';
import linkTheme from '../styles/libs/react-redux-app/Link/index.css.json';
import paginationTheme from '../styles/libs/react-redux-app/Pagination/index.css.json';
import tableTheme from '../styles/libs/react-redux-app/table/Table/index.css.json';
import vertTableTheme from '../styles/libs/react-redux-app/table/VertTable/index.css.json';
import tableSummaryTheme from '../styles/libs/react-redux-app/TableSummary/index.css.json';

import autocompleteTheme from '../styles/libs/react-redux-app/form/Autocomplete/index.css.json';
import checkboxTheme from '../styles/libs/react-redux-app/form/Checkbox/index.css.json';
import dayMonthYearTheme from '../styles/libs/react-redux-app/form/DayMonthYear/index.css.json';
import fieldTheme from '../styles/libs/react-redux-app/form/Field/index.css.json';
import formErrorTheme from '../styles/libs/react-redux-app/form/FormError/index.css.json';
import ibanTheme from '../styles/libs/react-redux-app/form/Iban/index.css.json';
import inputTheme from '../styles/libs/react-redux-app/form/Input/index.css.json';
import inputFileTheme from '../styles/libs/react-redux-app/form/InputFile/index.css.json';
import inputPasswordTheme from '../styles/libs/react-redux-app/form/InputPassword/index.css.json';
import inputTextWithAddonTheme from '../styles/libs/react-redux-app/form/InputTextWithAddon/index.css.json';
import multiSelectTheme from '../styles/libs/react-redux-app/form/MultiSelect/index.css.json';
import radioButtonTheme from '../styles/libs/react-redux-app/form/RadioButton/index.css.json';
import textareaTheme from '../styles/libs/react-redux-app/form/Textarea/index.css.json';

import menuTheme from '../styles/libs/react-redux-app/menu/Menu/index.css.json';
import menuItemTheme from '../styles/libs/react-redux-app/menu/MenuItem/index.css.json';
import menuItemLinkTheme from '../styles/libs/react-redux-app/menu/MenuItemLink/index.css.json';
import menuSubmenuTheme from '../styles/libs/react-redux-app/menu/Submenu/index.css.json';
import menuSubmenuItemTheme from '../styles/libs/react-redux-app/menu/SubmenuItem/index.css.json';
import menuSubmenuItemLinkTheme from '../styles/libs/react-redux-app/menu/SubmenuItemLink/index.css.json';

import modalTheme from '../styles/libs/react-redux-app/modal/Modal/index.css.json';
import modalsStackTheme from '../styles/libs/react-redux-app/modal/ModalsStack/index.css.json';


const contextTheme = {
  [RRA_ACTION_LINK]: actionLinkTheme,
  [RRA_ALERT]: alertTheme,
  [RRA_BUTTON]: buttonTheme,
  [RRA_BUTTON_SET]: buttonSetTheme,
  [RRA_CONFIRMATION]: confirmationTheme,
  [RRA_CONTEXT_MENU_LINK]: contextMenuTheme,
  [RRA_DROP_DOWN_MENU]: dropDownMenuTheme,
  [RRA_GRID_PAGINATION]: gridPaginationTheme,
  [RRA_GRID_PLACEHOLDER]: gridPlaceholerTheme,
  [RRA_HEADING]: headingTheme,
  [RRA_LINK]: linkTheme,
  [RRA_PAGINATION]: paginationTheme,
  [RRA_TABLE]: tableTheme,
  [RRA_VERT_TABLE]: vertTableTheme,
  [RRA_TABLE_SUMMARY]: tableSummaryTheme,

  [RRA_FORM_AUTOCOMPLETE]: autocompleteTheme,
  [RRA_FORM_CHECKBOX]: checkboxTheme,
  [RRA_FORM_DAY_MONTH_YEAR]: dayMonthYearTheme,
  [RRA_FORM_ERROR]: formErrorTheme,
  [RRA_FORM_FIELD]: fieldTheme,
  [RRA_FORM_IBAN]: ibanTheme,
  [RRA_FORM_INPUT]: inputTheme,
  [RRA_FORM_INPUT_FILE]: inputFileTheme,
  [RRA_FORM_INPUT_PASSWORD]: inputPasswordTheme,
  [RRA_FORM_INPUT_TEXT_WITH_ADDON]: inputTextWithAddonTheme,
  [RRA_FORM_MULTI_SELECT]: multiSelectTheme,
  [RRA_FORM_RADIO_BUTTON]: radioButtonTheme,
  [RRA_FORM_TEXTAREA]: textareaTheme,

  [RRA_MENU]: menuTheme,
  [RRA_MENU_ITEM]: menuItemTheme,
  [RRA_MENU_ITEM_LINK]: menuItemLinkTheme,
  [RRA_MENU_SUBMENU]: menuSubmenuTheme,
  [RRA_MENU_SUBMENU_ITEM]: menuSubmenuItemTheme,
  [RRA_MENU_SUBMENU_ITEM_LINK]: menuSubmenuItemLinkTheme,

  [RRA_MODAL]: modalTheme,
  [RRA_MODALS_STACK]: modalsStackTheme,
};

export default contextTheme;
